import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import { isUndefinedNullOrEmpty, stringContains } from '../../../js/utils';
import { reliablyHandleAsyncFormSubmit } from '../formUtils';
import sqlServerAuthTypes from './sqlServerAuthTypes';
import SqlServerInstanceForm from './SqlServerInstanceForm';
import { addSqlServerInstance, requestSqlServerInstanceValidation } from '../../../js/actions/sqlServerInstanceActionCreators';

const validationStatus = {
    success: 'success',
    failed: 'failed',
    cancelled: 'cancelled'
};

const SqlServerInstanceAddForm = React.createClass({
    setValidationSuccedded: null,
    setValidationFailed: null,
    propTypes: {
        agents: PropTypes.instanceOf(Map).isRequired,
        onSuccess: PropTypes.func,
        onCancel: PropTypes.func,
        getOperation: PropTypes.func.isRequired,
        addServerInstance: PropTypes.func.isRequired,
        startSqlServerInstanceValidation: PropTypes.func.isRequired
    },
    getInitialState: function () {
        return {
            validationOperationIdToTrack: null,
            validationStatus: null,
        };
    },
    validate: function (values) {
        const errors = {};

        if (isUndefinedNullOrEmpty(values.agentId)) {
            errors.agentId = 'An agent needs to be selected';
        }

        const instanceName = values.instanceName || '';//Is `undefined` when empty
        const machineName = !isUndefinedNullOrEmpty(values.agentId)
            ? this.props.agents.get(values.agentId).machineName
            : 'an agent from the above list';
        if (stringContains(instanceName, '\\') || instanceName.length > 16) {
            errors.instanceName = `Specify only the instance name of the SQL Server on ${machineName}, or leave blank for the default instance`;
        }

        if (isUndefinedNullOrEmpty(values.authenticationType)) {
            errors.authenticationType = 'Authentication Type is needed';
        }

        if (sqlServerAuthTypes.hasUsernameAndPassword(values.authenticationType)) {
            if (isUndefinedNullOrEmpty(values.sqlServerLogin)) {
                errors.sqlServerLogin = 'Login is needed';
            }

            if (isUndefinedNullOrEmpty(values.password)) {
                errors.password = 'Password is needed';
            }
        }

        return errors;
    },
    componentWillReceiveProps: function (nextProps) {
        const { getOperation } = nextProps;
        const { validationOperationIdToTrack } = this.state;

        if (!isUndefinedNullOrEmpty(validationOperationIdToTrack)) {
            const operation = getOperation(validationOperationIdToTrack);
            if (!isUndefinedNullOrEmpty(operation) && !isUndefinedNullOrEmpty(operation.resultDetails)) {
                const { resultDetails } = operation;
                if (resultDetails.isSuccess === true) {
                    this.setValidationSuccedded();
                } else {
                    this.setValidationFailed(resultDetails.errorMessage);
                }

                this.setState({
                    validationOperationIdToTrack: null,
                    validationStatus: resultDetails.isSuccess ? validationStatus.success : validationStatus.failed
                });
            }
        }
    },
    handleSubmit: function (data) {
        const { agents, startSqlServerInstanceValidation, addServerInstance, onSuccess } = this.props;
        const hasUsernameAndPassword = sqlServerAuthTypes.hasUsernameAndPassword(data.authenticationType);
        const serverToAdd = {
            server: agents.get(data.agentId).machineName, //Inferred server side, but needed locally until refresh
            instance: data.instanceName || '', //Allowed to be empty string for default instance
            agentId: data.agentId,
            authType: data.authenticationType,
            username: hasUsernameAndPassword ? data.sqlServerLogin : null,
            password: hasUsernameAndPassword ? data.password : null
        };

        return reliablyHandleAsyncFormSubmit(() => {
            this.setState({ validationStatus: null });
            return startSqlServerInstanceValidation(serverToAdd).then((operationDetails) => {
                this.setState({ validationOperationIdToTrack: operationDetails.id });
                return new Promise((resolve, reject) => {
                    this.setValidationSuccedded = resolve;
                    this.setValidationFailed = reject;
                });
            }).then(() => addServerInstance(serverToAdd)).then(addedServer => {
                if (onSuccess) {
                    onSuccess(addedServer);
                }
            });
        });
    },
    render: function () {
        const { onCancel } = this.props;
        const initialValues = {
            authenticationType: sqlServerAuthTypes.agentWindows
        };

        return <SqlServerInstanceForm actionName="Add" validate={this.validate} initialValues={initialValues} onValid={this.handleSubmit} onCancel={onCancel} />;
    }
});

const mapStateToProps = (state) => {
    return {
        agents: state.agents.value,
        getOperation: (operationId) => state.operations.value.get(operationId)
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        addServerInstance: (serverInstance) => {
            return dispatch(addSqlServerInstance(serverInstance));
        },

        startSqlServerInstanceValidation: (serverInstance) => {
            return dispatch(requestSqlServerInstanceValidation(serverInstance));
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(SqlServerInstanceAddForm);



// WEBPACK FOOTER //
// ./src/components/common/SqlServerInstanceSelection/SqlServerInstanceAddForm.jsx